const API = `https://amayabackend-production.up.railway.app/api`;

export const track = (event, meta) => {
  try {
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, meta }),
    }).catch(() => {});
  } catch (e) {}
};

export const submitLead = async (payload) => {
  const res = await fetch(`${API}/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Failed to submit");
  return res.json();
};

export const fetchLeads = async (key) => {
  const res = await fetch(`${API}/leads`, { headers: { "X-Admin-Key": key } });
  if (!res.ok) throw new Error("Unauthorized");
  return res.json();
};
